// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LWNGW8InIwgKhBTR0tek{margin-left:6px}.Obng4GCn7mAlE9VSigLB{margin-left:13px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownContent": `LWNGW8InIwgKhBTR0tek`,
	"dropdownContentMobile": `Obng4GCn7mAlE9VSigLB`
};
export default ___CSS_LOADER_EXPORT___;
